import React, { Component } from 'react';

class PrivacyPolicy extends Component {
    render() {

        return (
            <div className="container pb-5">
                <div className="row">
                    <div className="upload-content  col-sm-12 p-0 m-0">
                        {/* <div className="header">
                            <p style={{fontFamily:"Montserrat",fontSize:"20px",fontWeight:"bold"}}></p>
                        </div> */}
                        <h4 className='logmainheading mainheading'>
                            Privacy Policy
                        </h4>


                        <h6 className="ml-0 pl-0">Version as at November 3, 2023</h6>

                        <h5>About this policy</h5>

                        <ol>
                            <li>
                                KlickEx Pacific Ltd., trading as KlickEx Pacific (“KlickEx Pacific”, “we”, “our” or ”us”) provides payment infrastructure that simplifies cross-border payments and international commerce through a single payment connection. We seek to achieve low remittance costs and domestic digital inclusion as well as promote financial education by providing an online portal or website (website) that allows the easy, fast and affordable exchange of currencies.
                            </li>
                            <li>
                                We understand the importance of protecting your personal information. This Privacy Policy (Policy) outlines the types of personal information that we usually collect, the purposes for which we collect it, to whom we disclose it, how we hold and keep it secure and your rights in relation to your personal information, including how to complain and how we deal with complaints. It applies to the personal information of users of our website and related services we provide. It does not apply to that of our employees.
                            </li>
                        </ol>

                        <h5>Types of personal information we collect</h5>

                        <ol>
                            <li>
                                In this Policy, personal information means any information or opinion about an identified individual or an individual who is reasonably identifiable, whether true or not. It does not include information that is de-identified.
                            </li>
                            <li>
                                The types of personal information we collect about you depends on the dealings you have with us, and may include your name, date of birth, residential address, email address, phone number and other information we request or you provide when you open and maintain an account with us and use our services.
                            </li>
                            <li>
                                If you are a customer, we may also collect your ID documents for verification purposes, and your IP address when you login.
                            </li>
                            <li>
                                If you are applying for a job with us, we may also collect your:
                                <ol>
                                    <li>Employment history and qualifications;</li>
                                    <li>Academic records;</li>
                                    <li>References; and</li>
                                    <li>Criminal history record.</li>
                                </ol>
                            </li>
                        </ol>

                        <h5>Dealing with us anonymously or using a pseudonym</h5>

                        <ol>
                            <li>Where possible and lawful, you may interact with us anonymously or using a pseudonym. For example, if you contact us with a general question, we will not record your name unless we need it to adequately handle your question. In addition, you can visit our website without providing any personal information.</li>
                            <li>However, you cannot remain anonymous or use a pseudonym if you wish to use our products or services. We have legal obligations to verify your identity when you open an account with us and use our products or services.</li>
                        </ol>

                        <h5>Ways we collect your personal information</h5>

                        <ol>
                            <li>We may collect personal information from or about you in different ways, including:
                                <ol>
                                    <li>From you directly when you interact with us, e.g. your interaction with communications we send you, and your interaction with our website including registering an account, making customer enquiries and uploading verification documentation; and</li>
                                    <li>
                                        Through third parties with whom we interact in order to provide our services, including:
                                        <ol>
                                            <li>Through our agents registering an account on your behalf on our website and uploading verification documentation on your behalf; and
                                            </li>
                                            <li>Our service providers who verify your ID documents and facilitate any transactions you seek to make via our website.
                                            </li>
                                        </ol>
                                    </li>
                                </ol>
                            </li>

                            <li>
                                If you apply for a job or contract position with us, we may also collect personal information about you from third parties and publicly available sources, including:
                                <ol>
                                    <li>Recruiters;</li>
                                    <li>Government departments to verify your entitlement to work in Australia;</li>
                                    <li>Police agencies to obtain your criminal history record;</li>
                                    <li>Academic institutions;</li>
                                    <li>Your current or previous employers; and</li>
                                    <li>Your referees.</li>
                                </ol>
                            </li>
                        </ol>

                        <h5>Collection of information via our website</h5>

                        <ol>
                            <li>When you visit our website, we may also use ”cookies” or other similar tracking technologies that help us track your website usage and remember your preferences (such as through Google Analytics). Cookies are small files that store information on your computer, mobile phone or other device. They enable the entity that put the cookie on your device to recognise you across different websites, services, devices and/or browsing sessions. You can disable cookies through your internet browser, but our website may not work as intended for you if you do so.</li>
                            <li>Whilst we do not use browsing information to identify you personally, we may record certain information about your use of our website, such as which pages you visit, the time and date of your visit, search engine referrals and the internet protocol address assigned to your computer.</li>
                            <li>Our web pages may contain electronic images, known as web beacons. These electronic images enable us to count users who have visited certain pages on our website. Web beacons are not used by us to access your personal information, they are simply a tool we use to analyse which web pages are viewed, in an aggregate number.</li>
                        </ol>

                        <h5>Purposes for which we collect, use and disclose personal information</h5>

                        <ol>
                            <li>We collect, use and disclose your personal information for the following purposes:
                                <ol>
                                    <li>To verify your identity;</li>
                                    <li>To provide our services;</li>
                                    <li>To send receipts and correspondence;</li>
                                    <li>To manage and conduct our business;</li>
                                    <li>To offer or promote our products and services;</li>
                                    <li>To obtain feedback;</li>
                                    <li>To help us manage, develop and enhance our services, including our websites and applications;</li>
                                    <li>For business analysis, software development, troubleshooting, risk and administrative purposes;</li>
                                    <li>To consider your suitability for employment; and</li>
                                    <li>To comply with our legal obligations (such as those related to anti-money laundering and counter-terrorism financing).</li>
                                </ol>
                            </li>
                        </ol>

                        <h5>Disclosing your personal information</h5>

                        <ol>
                            <li>
                                We may disclose your personal information to the following:
                                <ol>
                                    <li>
                                        Our affiliates, for the purpose of providing our products and services to you, and in connection with the group”s risk management and compliance activities;
                                    </li>
                                    <li>
                                        Third parties in order to provide our services, for example:
                                        <ol>
                                            <li>Mobile network operators (i.e., where a payment remittance occurs via that mobile network operator);</li>
                                            <li>Our software provider that conducts ID verification checks;</li>
                                            <li>Our software provider that conducts politically exposed persons checks;</li>
                                            <li>Regulatory and risk mitigation providers, which undertake sanction screening, negative media screening and politically exposed person screening;</li>
                                        </ol>
                                    </li>
                                    <li>Organisations we contract to provide services on our behalf such as software suppliers and mail houses;</li>
                                    <li>Anyone to whom part or all of our assets or businesses are transferred or sold;</li>
                                    <li>Our professional advisers, including lawyers, accountants and auditors; and,</li>
                                    <li>Government agencies, regulatory bodies and law enforcement agencies, or other similar entities.</li>
                                </ol>
                            </li>
                        </ol>

                        <h5>Overseas disclosure and storage</h5>

                        <ol>
                            <li>Your personal information may be disclosed to our affiliates as described in paragraph 7.1(a) of this Policy, which are based or have employees based in Samoa, Canada, India, Malaysia, the Philippines, Thailand, the United States of America and Europe.</li>
                            <li>Some of the other organisations to whom we may disclose your personal information (see section 7 of this Policy) may be located in Europe (identity verification provider), the United Kingdom (identity verification provider) and other countries.</li>
                        </ol>

                        <h5>Direct marketing</h5>

                        <ol>
                            <li>We may, with consent where required, use your personal information to identify a product or service that you may be interested in and to contact you from time to time (including by email, SMS, and social media) to tell you about products, services, news, deals (including special offers) and other information we believe could be of interest to you.</li>
                            <li>You can opt-out of receiving direct marketing communications from us at any time by by clicking on the ‘unsubscribe’ link in the marketing communication, and in the case of social media direct marketing communications, by updating your preferences on social media.</li>
                        </ol>

                        <h5>Security and storage</h5>

                        <ol>
                            <li>
                                We store your personal information in hard copy and electronically (including with third party storage providers). We take all reasonable steps to protect your personal information from misuse, interference and loss, as well as unauthorised access, modification or disclosure.
                            </li>
                            <li>
                                We only keep your personal information for as long as it is required for a purpose for which the information may be used or disclosed under the Privacy Act 2020 or as otherwise required by applicable laws. If we no longer need to hold your personal information for any reason or we are no longer required by law to keep it, we will take reasonable steps to de-identify or destroy that information. These steps may vary depending on the nature of the information, the way it was collected and how it was stored.
                            </li>
                        </ol>

                        <h5>
                            Access to and correction of your information
                        </h5>

                        <ol>
                            <li>
                                We will endeavour to ensure that the personal information collected from you is up to date, accurate and complete.
                            </li>
                            <li>You may request access to, or correction of, the personal information we hold about you at any time by logging in and updating your details on our website or contacting KlickEx Pacific Support at support@klickex.com . If you are represented by an agent, your agent may also call Customer Care on (+64) 9 3775539 or email KlickEx Pacific Support at support@klickex.com . We may need to verify your identity before responding to your request. Subject to any applicable exceptions or requirements, we will provide you with access to the personal information you request within a reasonable time and usually within 28 days. If we decide to refuse your request, in most circumstances we will tell you why in writing and how to complain.</li>
                        </ol>

                        <h5>Changes to policy</h5>

                        <ol>
                            <li>We may change this Policy from time to time, by publishing changes on our website. The revised Policy will be effective on the date it is published. The date of the current version is at the top of this Policy.</li>
                        </ol>

                        <h5>Complaints</h5>

                        <ol>
                            <li>
                                You can make a complaint in writing by emailing KlickEx Pacific Support at support@klickex.com. Your complaint will be assigned to and managed by the Customer Care Manager. We will respond to you within a reasonable period of time to acknowledge your complaint and inform you of the next steps we will take in dealing with your complaint.
                            </li>
                            <li>
                                Depending on the nature of your complaint, we may escalate the issue to our Operations Manager, CFO or CEO.
                            </li>
                            <li>
                                If you are not satisfied with our response, you may complain to the Office of the New Zealand Privacy Commissioner via its website, https://www.privacy.org.nz/.
                            </li>
                        </ol>

                        <h5>
                            Contact us
                        </h5>

                        <p>
                            If you have a question or comment regarding this Policy or wish to make a complaint or exercise your privacy rights, please contact KlickEx Pacific Support using the following details:
                        </p>

                        <p>
                            support@klickex.com
                            <br />
                            KlickEx Pacific
                            <br />
                            Level 1, Quad 7, 6 Leonard Isitt Drive,
                            <br />
                            Auckland Airport, Auckland,
                            <br />
                            New Zealand, 2022
                            <br />
                            Ph:(+64) 9 3775539
                        </p>


                    </div>

                </div>
            </div>
        );
    }
}

export default PrivacyPolicy;


// WEBPACK FOOTER //
// ./src/components/privacypolicy/privacypolicy.jsx